<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('full_proposal_ev.admissibility__reference')}}</p>
        <span>{{application.reference_nr}}</span>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-0">Total Score</p>
        <span>{{totalScore}}</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['application', 'evaluations'],
    computed: {
      totalScore() {
        let vm = this;

        let total = 0;
        vm.evaluations.forEach(function(item) {
          total += item.total_score;
        })

        if(vm.evaluations.length) {
          total = (total / vm.evaluations.length);
        }

        if(total === 0) {
          return '-';
        } else {
          return total.toFixed(0);
        }
      }
    },
  }
</script>